<b3-modal [open]="true" overlay size="md" (b3-close)="close()">
  <b3-modal-header
    *ngIf="title"
    [heading]="title"
    aria-level="2"
    [icon]="headerIcon"
    [attr.icon-tone]="headerIconTone"
    [attr.close-aria-label]="closeButton ? 'Fechar' : null"
    (b3-close)="close()">
  </b3-modal-header>

  <b3-modal-body>
    <div class="box">
      <div id="modal-body-content" [innerHTML]="safeContent"></div>
      <form [formGroup]="formRegister">
        <div>
          <app-b3-textarea mask="" [maxlength]="100" [validate]="true" placeholder="Limite 100 caracteres"
            label="Motivo" type="text" inputId="reasonText" formControlName="reasonText">
          </app-b3-textarea>
        </div>
      </form>
    </div>
  </b3-modal-body>

  <b3-modal-footer>
    <div *ngIf="modalType === 'confirmation' && actionType === 'reject'" class="app-modal-confirmation__footer">
      <b3-button type="button" variant="outlined" tone="default" id="modal_cancel" (b3-click)="close()">
        Cancelar
      </b3-button>
      <b3-button
        type="button"
        variant="filled"
        tone="default"
        id="btn_confirm_modal"
        [disabled]="formRegister.invalid"
        (b3-click)="confirm()">
        Rejeitar
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
